import { Container, Typography } from "@mui/material";
import { Helmet } from "react-helmet-async";
import { useEffect } from "react";
import CalendarSection from "../components/Calendar/CalendarSection";
import ResultBadge from "../components/Home/ResultBadge"

function Calendar() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <>
      <Helmet>
        <title>Liga Deportiva Cantonal Mejía</title>
        <meta
          name="description"
          content="Official schedule of the SAAC Basketball Quito 2026 tournament."
        />
      </Helmet>
      <CalendarSection />
      <ResultBadge />

    </>
  );
}

export default Calendar;